import { useEffect, useState } from "react";
import {
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Button,
	MenuItem,
	TextField,
	FormControlLabel,
	Switch,
	Box,
	ToggleButton,
	ToggleButtonGroup,
	Typography,
} from "@mui/material";
import SeletorClienteHost from "../seletorClienteHost";

// Modal para criar uma exceção de exibição (liga/desliga um tipo de alerta
// para um cliente ou um host específico). O padrão global é editado direto na
// lista da aba, não aqui.
export default function ModalExcecao({
	open,
	onClose,
	tipos = [],
	clientes = [],
	allHosts = [],
	onSalvar,
}) {
	const [escopo, setEscopo] = useState("HOST");
	const [clienteId, setClienteId] = useState(null);
	const [hostId, setHostId] = useState(null);
	const [tipoAlertaId, setTipoAlertaId] = useState("");
	const [visivel, setVisivel] = useState(true);
	const [salvando, setSalvando] = useState(false);

	// Reseta o formulário sempre que reabrir.
	useEffect(() => {
		if (open) {
			setEscopo("HOST");
			setClienteId(null);
			setHostId(null);
			setTipoAlertaId("");
			setVisivel(true);
			setSalvando(false);
		}
	}, [open]);

	const podeSalvar =
		tipoAlertaId &&
		clienteId &&
		(escopo === "CLIENTE" || (escopo === "HOST" && hostId));

	const handleSalvar = async () => {
		setSalvando(true);
		try {
			await onSalvar({
				tipoAlertaId,
				escopo,
				clienteId,
				hostId: escopo === "HOST" ? hostId : null,
				visivel,
			});
		} finally {
			setSalvando(false);
		}
	};

	return (
		<Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
			<DialogTitle>Nova exceção de exibição</DialogTitle>
			<DialogContent>
				<Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
					Sobrescreve o padrão global de um tipo de alerta para um cliente ou um
					host específico. Precedência: host &gt; cliente &gt; padrão global.
				</Typography>

				<Box sx={{ mb: 2 }}>
					<Typography variant="caption" color="text.secondary">
						Escopo
					</Typography>
					<ToggleButtonGroup
						exclusive
						size="small"
						value={escopo}
						onChange={(_, v) => {
							if (v) {
								setEscopo(v);
								if (v === "CLIENTE") setHostId(null);
							}
						}}
						sx={{ display: "block", mt: 0.5 }}
					>
						<ToggleButton value="CLIENTE">Por cliente</ToggleButton>
						<ToggleButton value="HOST">Por host</ToggleButton>
					</ToggleButtonGroup>
				</Box>

				<TextField
					select
					fullWidth
					size="small"
					label="Tipo de alerta"
					value={tipoAlertaId}
					onChange={(e) => setTipoAlertaId(e.target.value)}
					sx={{ mb: 2 }}
				>
					{tipos.map((t) => (
						<MenuItem key={t.id} value={t.id}>
							{t.nome}
						</MenuItem>
					))}
				</TextField>

				<SeletorClienteHost
					clientes={clientes}
					allHosts={allHosts}
					clienteId={clienteId}
					onClienteChange={setClienteId}
					hostId={hostId}
					onHostChange={setHostId}
					exigirHost={escopo === "HOST"}
				/>

				<FormControlLabel
					sx={{ mt: 2 }}
					control={
						<Switch
							checked={visivel}
							onChange={(e) => setVisivel(e.target.checked)}
						/>
					}
					label={visivel ? "Exibir este tipo" : "Ocultar este tipo"}
				/>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose} disabled={salvando}>
					Cancelar
				</Button>
				<Button
					variant="contained"
					onClick={handleSalvar}
					disabled={!podeSalvar || salvando}
				>
					Salvar
				</Button>
			</DialogActions>
		</Dialog>
	);
}
